import { render, staticRenderFns } from "./ContactTags.vue?vue&type=template&id=4ce4af42&"
import script from "./ContactTags.vue?vue&type=script&lang=js&"
export * from "./ContactTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports